import { render } from "./App.vue?vue&type=template&id=10b0ba26"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=10b0ba26&lang=css"

import exportComponent from "/Users/josecisneros/Desktop/Jose-Cisneros/Portfolio-Site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__